module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00025.c9d70ed1.png";